<template>
  <v-dialog v-model="visible" max-width="800">
    <v-card>
      <v-card-title>
        {{
          client
            ? "WireGuard client configuration template"
            : "WireGuard server configuration"
        }}
      </v-card-title>
      <v-card-text>
        <v-form ref="editForm" lazy-validation>
          <div class="d-flex">
            <v-textarea
              ref="template"
              v-model="template"
              v-bind:rules="[rules.required]"
              rows="13"
              hide-details
              outlined
              autofocus
            />
            <div
              v-if="client"
              style="width: 200px"
              class="rounded grey darken-2 pa-2 ml-3 white--text"
            >
              <p class="font-weight-bold">
                Variables that can be used in substitutions:
              </p>

              <div
                v-on:click="copyVariable(variable)"
                v-for="variable in variables"
                v-bind:key="variable"
              >
                <v-hover v-slot="{ hover }">
                  <div>
                    <v-icon color="white" small>
                      {{ hover ? "mdi-content-copy" : "mdi-circle-medium" }}
                    </v-icon>
                    %{{ variable }}%
                  </div>
                </v-hover>
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-on:click="save" text> Save </v-btn>
        <v-btn v-on:click="visible = false" text> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "WireGuardTemplate",

  props: {
    value: { type: String, default: null }
  },

  data: () => ({
    template: null,
    variables: [],
    rules: {
      required: value => !!value || "Mandatory field"
    }
  }),

  computed: {
    visible: {
      get() {
        return !!this.value;
      },
      set(visible) {
        visible === false && this.$emit("input", null);
      }
    },
    client() {
      return this.value == "client";
    }
  },

  watch: {
    visible(visible) {
      visible &&
        this.$server
          .query({ url: this.client ? "boxes/wg-template" : "boxes/wg-config" })
          .then(data => {
            this.template = data.template;
            this.variables = data.variables;
            this.$refs.editForm.resetValidation();
          });
    }
  },

  methods: {
    // Save template
    save() {
      this.$refs.editForm.validate() &&
        this.$server
          .update({
            url: this.client ? "boxes/wg-template" : "boxes/wg-config",
            data: { template: this.template }
          })
          .then(() => (this.visible = false));
    },

    // Copy variable into clipboard
    copyVariable(variable) {
      this.clipboard_copy(`%${variable}%`, "Variable copied");
    }
  }
};
</script>
